import { render, staticRenderFns } from "./batchReturn.vue?vue&type=template&id=f80c0f4a&scoped=true"
import script from "./batchReturn.vue?vue&type=script&lang=js"
export * from "./batchReturn.vue?vue&type=script&lang=js"
import style0 from "./batchReturn.vue?vue&type=style&index=0&id=f80c0f4a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80c0f4a",
  null
  
)

export default component.exports